import { Price } from '../../components';
import { centsToFixed2 } from '../utils';

export const metaEventPurchase = (bookingId: string, actionPayload: any, eventID: string) => {
  if (!actionPayload) {
    return;
  }

  const contentIds = actionPayload?.cart?.items.map((item: { itemId: string }) => item.itemId);

  fbq(
    'track',
    'Purchase',
    {
      order_id: bookingId,
      currency: actionPayload?.system?.unitsConfig?.currency,
      value: centsToFixed2(actionPayload?.cart?.discountedPriceWithoutDeposit.gross), // Total transaction value (incl. tax and shipping)
      content_ids: contentIds,
      content_type: 'product',
      contents: actionPayload?.cart?.items.map((item: { itemId: string; name: string; qty: number; individualDiscountedPrice: Price; individualPrice: Price }) => ({
        id: item.itemId,
        quantity: item.qty,
        price: centsToFixed2(item.individualDiscountedPrice?.gross || item.individualPrice?.gross),
        item_name: item.name,
      })),
      num_items: actionPayload?.cart?.items?.length,
    },
    { eventID: eventID },
  );
};

export const metaEventAddToCart = (params: any, currency: string) => {
  fbq('track', 'AddToCart', {
    content_ids: [params.itemId],
    content_type: 'product',
    currency: currency,
    value: params.price?.net ? centsToFixed2(params.price.net) : undefined,
  });
};

export const metaInitiateCheckout = (state: any) => {
  fbq('track', 'InitiateCheckout', {
    value: centsToFixed2(state.amountToPay.total),
    currency: state.currency,
  });
};

export const metaAddCustomer = (actionPayload: any, metaPixelId: string) => {
  fbq('init', metaPixelId, {
    em: actionPayload.email,
    fn: actionPayload['shipping.firstName'] || actionPayload.firstName,
    ln: actionPayload['shipping.lastName'] || actionPayload.lastName,
    ct: actionPayload['shipping.city'] || actionPayload.city,
    zp: actionPayload['shipping.zipCode'] || actionPayload.zipCode,
    country: actionPayload['shipping.country'] || actionPayload.country,
  });
};
